import styled, {css} from "styled-components"
import {Select} from "@irati/ui/src/FormItem"
import Input from "@irati/ui/src/FormItem/Input"
import src from "./subscription-icon.svg"

export const Icon = styled.img.attrs({src, alt: ""})`
  object-fit: contain;
`

export const Circle = styled.div`
  height: 100%;
  border-radius: 9999px;
  background-color: ${({theme}) => theme.colors.greys.white};
  padding: 30px;

  & > img {
    width: 55px;
  }
`

export const FlexGrow = styled.span`
  text-align: center;
  flex: 1;
`

export const DurationSelect = styled(Select)`
  /* HACK: this magic number is the width of the longest text in the select options plus a cursor (created by React-select) */
  flex: 0 0 185px;
`

export const AmountInput = styled(Input)`
  flex-grow: 1;

  /* override the width set by the Form 'inline' component */
  .form-control {
    width: 100%;
  }
`

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas:
    "leftHeader rightHeader"
    "leftPrice rightPrice";
  column-gap: ${({theme}) => theme.spacing.two};
`

export const GridSection = styled.div<{area: "leftHeader" | "rightHeader" | "leftPrice" | "rightPrice"}>`
  grid-area: ${({area}) => area};
  ${({area}) =>
    ["leftHeader", "rightHeader"].includes(area)
      ? css`
          border-top-left-radius: ${({theme}) => theme.border.radius.medium};
          border-top-right-radius: ${({theme}) => theme.border.radius.medium};
          padding: ${({theme}) => theme.spacing.one};
          background-color: ${({theme}) => theme.colors.greys.black};
          & > * {
            color: ${({theme}) => theme.colors.greys.white};
          }
        `
      : css`
          border-bottom-left-radius: ${({theme}) => theme.border.radius.medium};
          border-bottom-right-radius: ${({theme}) => theme.border.radius.medium};
          padding: ${({theme}) => theme.spacing.two} 0;
          background-color: ${({theme}) => theme.colors.greys.light};
          text-align: center;
        `}
`

export const StyledFlex = styled.div`
  display: flex;
  background-color: ${({theme}) => theme.colors.greys.light};
  align-items: center;
  padding: ${({theme}) => theme.spacing.two} 0;
`
